import { defineComponent as e } from "vue";
import t from "./component-library3.js";
const r = /* @__PURE__ */ e({
  __name: "variant-selector-basic",
  props: {
    isAccessible: { type: Boolean, default: !0 },
    displayName: { default: void 0 },
    variants: { default: () => [] }
  },
  emits: ["select-variant"],
  setup(a) {
    return { __sfc: !0, LinkButton: t };
  }
});
export {
  r as default
};
